<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="fileupload fileupload-dropzone-directive fileinput-button bs3-margin-bottom" :data-file-list-id="pFileListRef.id">
        <i class="fa-light fa-cloud-upload" aria-hidden="true"></i> {{ 'dictionary.file.drop.or.select' | i18nText(pDictionary) }}
        <input type="file" name="upload" multiple>
      </div>
      <file-upload-table
          :p-dictionary="pDictionary"
          :p-data-form-input-name="pDataFormInputName"
          :p-uploading-files="uploadingFiles">
      </file-upload-table>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import FileUploadTable from "@/components/modules/file-module/file/upload/FileUploadTable";

export default {
  name: "FileUploadDropzone",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  components: {FileUploadTable},
  props: {
    pParentId: {
      type: String,
      required: true
    },
    pDataFormInputName: {
      type: String,
      default: function () {
        return 'dataForm';
      }
    },
    pFileListRef: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      uploadingFiles: []
    }
  },
  methods: {
    refreshUploadingFiles: function () {
      let _component = this;
      $.ajax({
               type: "POST",
               url: "/mediaplan/app/endpoints/json-api/files/uploading",
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (data) {
        _component.uploadingFiles.splice(0);
        $.each(data, function (index, invoice) {
          _component.uploadingFiles.push(invoice);
        });
      });
    }
  },
  mounted: function () {
    let $parent = $(this.pParentId);
    $parent.initAjaxUploadFiles($parent, this.pDataFormInputName);

    this.refreshUploadingFiles();
  },
  destroyed: function () {
    let $parent = $(this.pParentId);
    $parent.destroyAjaxFileUpload($parent);
  }
}
</script>

<style scoped>

</style>